<template>
  <div class="offcanvas offcanvas-end px-2" tabindex="-1" :id='id' :aria-labelledby=id>
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasExampleLabel">{{ title }}</h5>
      <button type="button" class="close" data-bs-dismiss="offcanvas" aria-label="Close">
        <i class="fa fa-close"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "VsudRightSideFilter",
  props: {
    id: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
  },
  mounted() {
    // console.log("mounted")
  },
  methods: {
    closeFilter() {
      const closeButton = document.querySelector('.close');
      closeButton.click();
    }
  }
};
</script>

<style scoped>
button.close {
  border: none;
  background: transparent;
  opacity: 0.7;
}

button.close:hover {
  opacity: 1;
}

button.close i {
  color: var(--black);
  font-size: 1.1rem;
}

.offcanvas-end {
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.2);
}
</style>
